import * as React from "react";

import Router from "next/router";
import { Grid } from "tabler-react";
const queryString = require("query-string");
import * as _ from "lodash";

import Search from "../Search";
import Filter from "../Filter";
import JobCard from "../JobCard";
import HireXLPagination from "../Pagination";
import { ErrorPageNoJob } from "../ErrorPage";

class Jobs extends React.Component {
  constructor(props) {
    super(props);

    this.onFilterChange = this.onFilterChange.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
    this.fetchJobs = this.fetchJobs.bind(this);

    this.state = {
      keywords: [],
      locality: [],
      exp: "",
      salary: "",
      page: "",
      url: "/jobs?search=true",
      activePage: 1,
      filters: [],
    };
  }

  componentWillMount() {
    this.setState({
      keywords: [...this.props.appliedFilters.keywords],
    });
  }

  onFilterChange(name) {
    if (this.state.keywords.indexOf(name) == -1) {
      this.setState(
        {
          keywords: [...this.state.keywords, name],
        },
        () => this.fetchJobs()
      );
    } else {
      this.setState(
        {
          keywords: this.state.keywords.filter((prevName) => {
            return prevName !== name;
          }),
        },
        () => this.fetchJobs()
      );
    }
  }

  handlePageChange(pageNumber) {
    window.scrollTo(0, 0);
    this.setState(
      {
        page: pageNumber,
      },
      () => {
        let obj = {
          keywords:
            this.state.keywords && this.state.keywords.length
              ? this.state.keywords.toString()
              : null,
          locality:
            this.props.appliedFilters && this.props.appliedFilters.locality
              ? this.props.appliedFilters.locality.toString()
              : null,
          salary:
            this.props.appliedFilters && this.props.appliedFilters.salary
              ? this.props.appliedFilters.salary
              : null,
          exp:
            this.props.appliedFilters && this.props.appliedFilters.exp
              ? this.props.appliedFilters.exp
              : null,
          page: this.state.page,
        };

        let query = _.pickBy(obj, _.identity);
        const urlParams = queryString.stringify(query);
        Router.push("/jobs?search=true&&" + urlParams);
      }
    );
  }

  // Fetch Jobs after applying filter
  fetchJobs() {
    let obj = {
      keywords:
        this.state.keywords && this.state.keywords.length
          ? this.state.keywords.toString()
          : null,
      locality:
        this.props.appliedFilters && this.props.appliedFilters.locality
          ? this.props.appliedFilters.locality.toString()
          : null,
      salary:
        this.props.appliedFilters && this.props.appliedFilters.salary
          ? this.props.appliedFilters.salary
          : null,
      exp:
        this.props.appliedFilters && this.props.appliedFilters.exp
          ? this.props.appliedFilters.exp
          : null,
    };

    let query = _.pickBy(obj, _.identity);

    const urlParams = queryString.stringify(query);
    window.location.href = `/jobs?search=true&&${urlParams}`;
  }

  render() {
    let filters = this.props.functionalArea ? this.props.functionalArea : [];
    filters = filters.map((filterObj) => {
      filterObj.secondaryArea = filterObj.secondaryArea.map((obj) => {
        if (this.state.keywords.indexOf(obj.name) == -1) {
          obj["checked"] = false;
        } else {
          obj["checked"] = true;
        }
        return obj;
      });
      return filterObj;
    });

    return (
      <div className="container wrapper-padding job-list">
        <Grid.Col width={12}>
          <Grid.Col width={12} className="job-search-wrapper">
            <Search
              cities={this.props.cities}
              functionalArea={this.props.functionalAreaSearch}
              appliedFilters={this.props.appliedFilters}
            />
          </Grid.Col>
        </Grid.Col>
        <Grid.Row className="margin-none">
          <Grid.Col width={3} className="sidebar">
            <Filter
              functionalArea={filters}
              onFilterChange={this.onFilterChange}
            />
          </Grid.Col>
          <Grid.Col lg={9} md={9} xs={12} className="job-wrapper">
            {this.props.jobs.length ? (
              this.props.jobs.map((job) => {
                return <JobCard key={`job-item-${job.id}`} jobs={job} />;
              })
            ) : (
              <ErrorPageNoJob
                title="Oh Oh!"
                subtitle="We could not find jobs matching your search criteria."
                details="You can browse jobs by Functional Area, Industry, Company, Skills and Designations"
              />
            )}
            {this.props.totalPage ? (
              <HireXLPagination
                itemsCountPerPage={10}
                totalItemsCount={this.props.totalPage * 10}
                pageRangeDisplyed={7}
                handlePageChange={this.handlePageChange}
                activePage={parseInt(this.props.appliedFilters.page)}
              />
            ) : null}
          </Grid.Col>
        </Grid.Row>
      </div>
    );
  }
}

export default Jobs;
